import React from "react";
import PropTypes from 'prop-types'
import {connect} from 'react-redux'
import * as Yup from 'yup'
import {Row, Col, Modal, Icon} from 'antd'
import {FastField, Formik} from 'formik'
import typo from '../../../constants/dictionaries'

// Components
import Input from '../../Common/Input'
import Button from '../../Buttons'
import ValidatedText from "../../Common/ValidatedText";
import DisplayFormikState from "../../Table/DisplayFormikState";
import Api from '../../../api';
import Message from "../../Messages";
import Api_quantrac from "../../../api/api.quantrac";

const schema = Yup.object().shape({
  tenDuAn: Yup.string().required("Tên dự án không được trống"),
  diaChi: Yup.string().required("Địa chỉ dự án không được trống"),
});

const Du_AnModal = ({
  isOpen = false,
  handleOk,
  handleCancel,
  user
  }) => {
  return (
    <Modal
      visible={isOpen}
      title={typo.cscore_add_duan}
      footer={false}
      onCancel={handleCancel}
    >
      <Formik
        enableReinitialize
        initialValues={{}}
        onSubmit={(value, actions) => {
          actions.resetForm({});
          new Api_quantrac().PostDMDuAn({token: user.access_token, data: value})
            .then(res => {
              handleOk(res);
            })
            .catch((err) => Message.error(err.message))
        }}
        validationSchema={schema}
        render={({handleChange, handleSubmit, values, errors, touched}) => (
          <form onSubmit={handleSubmit} autoComplete={false}>
            <Row>
              <FastField
                name="tenDuAn"
                render={({field}) => <Input label={typo.cscore_input_tenduan_ten} {...field}/>}
              />
              {touched.tenDuAn && <ValidatedText type="danger">{errors.tenDuAn}</ValidatedText>}

              <FastField
                name="diaChi"
                render={({field}) => <Input label={typo.cscore_input_address} id="diaChi" {...field}/>}
              />
              {touched.diaChi && <ValidatedText type="danger">{errors.diaChi}</ValidatedText>}
            </Row>
            <div className="mt-20"/>
            <Row type="flex" justify="end" align="middle">
              <Button type="submit" onClick={handleSubmit}><Icon type="save"/>{typo.cscore_save}</Button>
              <div className="ml-10"/>
              <Button type="cancel" onClick={handleCancel}><Icon type="arrow-right" />{typo.cscore_exit}</Button>
            </Row>
            {/*<DisplayFormikState error={errors} value={values}/>*/}
          </form>
        )}/>
    </Modal>
  )
};

Du_AnModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  handleOk: PropTypes.func.isRequired,
  handleCancel: PropTypes.func.isRequired,
};

const mapStateToProps = (store) => ({
  user: store.oidc.user
});

export default connect(mapStateToProps)(Du_AnModal);

